import { Location } from '@reach/router';
import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react';
import { useState } from 'react';
import { FlagButton, MenuItemButton, MobileOnlySubMenuToggleButton, SubMenuToggleButton } from '../components/Button';
import { GreatBritainFlag } from '../components/GreatBritainFlag';
import {
  HeaderMenu,
  HeaderMenuItem,
  HeaderSubMenu,
  HeaderSubMenuItem
} from '../components/Header';
import { SwedenFlag } from '../components/SwedenFlag';
import {
  IDefaultProps,
  IDefaultPropsWithDataAndLocation
} from '../IDefaultProps';
import { Query } from '../types/graphql-types';
import { activeLocale } from '../utils/activeLocale';
import { availableLocales } from '../utils/availableLocales';
import { GetLinkFromId } from '../utils/getLinkFromId';
import { getTranslations } from '../utils/translations';

interface IToggle {
  render: (toggle: boolean) => any
}

const Toggle = ({ render }: IToggle) => {
  const [open, setOpen] = useState(false);
  const onToggleClick = () => setOpen(!open);

  return <HeaderMenuItem onClick={onToggleClick}>{render(open)}</HeaderMenuItem>
};

const Content = ({ data, location }: IDefaultPropsWithDataAndLocation) => {
  const currentLocale = activeLocale(location, availableLocales())
  const menu =
    data.allContentfulMenu &&
    data.allContentfulMenu.edges &&
    data.allContentfulMenu.edges.find(
      edge =>
        edge!.node!.node_locale === currentLocale
    );

  if (!menu) {
    return null;
  }

  const languagesButtonText = 
    data.allContentfulTranslation &&
    data.allContentfulTranslation.edges &&
    data.allContentfulTranslation.edges.find(
      edge =>
        edge!.node!.node_locale === currentLocale &&
        edge!.node!.key === 'Languages'
    )!.node!.value

  const { items } = menu.node!;

  return (
    <HeaderMenu>
      {items &&
        items.map((item: any) => {
          if (item.items) {
            return (
// tslint:disable-next-line: jsx-no-lambda
              <Toggle key={item.id} render={(toggle: boolean) => (
                <>
                  <SubMenuToggleButton>{item.name} ></SubMenuToggleButton>
                  <HeaderSubMenu openService={toggle}>
                    {item.items.map((x: any) => {
                      if (!GetLinkFromId(x.id)) {
                        return;
                      }
                      return (
                      <HeaderSubMenuItem key={x.id}>
                        <MenuItemButton to={GetLinkFromId(x.id)!}>
                          {x.name}
                        </MenuItemButton>
                      </HeaderSubMenuItem>)
                    })}
                  </HeaderSubMenu>
                </>
              )}/>
            );
          }

          if (!GetLinkFromId(item.id)) {
            return;
          }
          return (
            <HeaderSubMenuItem key={item.id}>
              <MenuItemButton to={GetLinkFromId(item.id)!}>
                {item.name}
              </MenuItemButton>
            </HeaderSubMenuItem>)
          }
        )}
{/*tslint:disable-next-line: jsx-no-lambda*/}
      <Toggle key="languages" render={(toggle: boolean) => (
        <>
          <MobileOnlySubMenuToggleButton>{languagesButtonText} ></MobileOnlySubMenuToggleButton>
          <HeaderSubMenu openService={toggle}>
            <HeaderSubMenuItem key="sv">
              <MenuItemButton to="/sv-se">
                <SwedenFlag />
                SV
              </MenuItemButton>
            </HeaderSubMenuItem>
            <HeaderSubMenuItem key="en">
              <MenuItemButton to="/en-us">
                <GreatBritainFlag />
                EN
              </MenuItemButton>
            </HeaderSubMenuItem>
          </HeaderSubMenu>
        </>
      )}/>
    </HeaderMenu>
  );
};

export const Menu = (props: IDefaultProps) => {
  const data: Query = useStaticQuery(graphql`
    query {
      allContentfulMenu(filter: { name: { eq: "Primary" } }) {
        edges {
          node {
            node_locale
            items {
              __typename
              ... on Node {
                ... on ContentfulMenuItem {
                  id
                  name
                  items {
                    __typename
                    ... on Node {
                      ... on ContentfulMenuItem {
                        id
                        name
                      }
                      ... on ContentfulService {
                        id
                        name
                      }
                    }
                  }
                }
                ... on ContentfulPage {
                  id
                  name
                }
              }
            }
          }
        }
      }
      allContentfulTranslation(filter: {key: {in: ["Languages"]}}) {
        edges {
          node {
            key
            value
            node_locale
          }
        }
      }
    }
  `);

  return (
    <Location>
      {location => <Content data={data} {...location} {...props} />}
    </Location>
  );
};
